import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "./slice/home-slice";
import searchSlice from "./slice/search-slice";
import shopSlice from "./slice/shop-slice";

const store = configureStore({
    reducer: {
        home: homeSlice.reducer,
        search: searchSlice.reducer,
        shop: shopSlice.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }),
});

export default store;
